import { createFileRoute } from "@tanstack/react-router";

import { ProjectList } from "../projects/ProjectList";
import { projectsQueryOptions } from "../projects/queries";

export const Route = createFileRoute("/_auth/projects/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(projectsQueryOptions),
  component: ProjectList,
});
